export default {
  "category.shoes": "Shoes",
  "category.hoodies": "Hoodies / Sweaters",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jackets",
  "category.pants": "Pants / Shorts",
  "category.headwear": "Headwear",
  "category.sets": "Sets",
  "category.underwear": "Underwear / Underpants",
  "category.jersey": "Jersey",
  "category.accessories": "Accessories",
  "category.bags": "Bags",
  "category.belts": "Belts",
  "category.perfumes": "Perfumes",
  "category.other": "Other Stuff",
};